import sdl from '@jds/react-generated-sdl/JDSTag';
import type { JDSTagProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, TagProps } from '../logic';

const Component = (props: TagProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    size = 'medium',
    kind = 'toggle',
    disabled = false,
    active = false,
    ariaLabel = props.label?.toString(),
    _ariaPressed = props.active?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { size, kind, disabled, active, ariaLabel, _ariaPressed, ...rest },
    'JDSTag',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Tag = withLogic(Component) as React.FC<TagProps> & { slotName?: string };

Tag.displayName = 'Tag';
Tag.slotName = 'jds_tag';

export { Tag, type JDSTagProps };
